import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsComp from '@/features/commands/components/extensions/commands'

export const Route = createFileRoute('/_authenticated/commands/')({
  component: CommandsComp,
  validateSearch: validateCommandsPageSearchParams,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes`,
      },
    ],
  }),
})
